@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.notification.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mobile_wallet.feature.notification.generated.resources/"

internal val Res.string.feature_notification_error_oops: StringResource by lazy {
      StringResource("string:feature_notification_error_oops", "feature_notification_error_oops", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 10, 55),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 10, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 47),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10, 51),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 10, 47),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 10, 47),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 10, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 47),
      ))
    }

internal val Res.string.feature_notification_loading: StringResource by lazy {
      StringResource("string:feature_notification_loading", "feature_notification_loading", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 66, 68),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 66, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 62, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 58, 52),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 62, 80),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 58, 44),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 58, 52),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 62, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58, 48),
      ))
    }

internal val Res.string.feature_notification_nothing_to_notify: StringResource by lazy {
      StringResource("string:feature_notification_nothing_to_notify", "feature_notification_nothing_to_notify", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 135, 86),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 139, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 111, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 111, 70),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 143, 138),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 103, 94),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 111, 70),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 111, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107, 70),
      ))
    }

internal val Res.string.feature_notification_notifications: StringResource by lazy {
      StringResource("string:feature_notification_notifications", "feature_notification_notifications", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 222, 66),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 246, 78),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 182, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 182, 62),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 282, 70),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 198, 58),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 182, 62),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 182, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178, 62),
      ))
    }

internal val Res.string.feature_notification_there_is_nothing_to_show: StringResource by lazy {
      StringResource("string:feature_notification_there_is_nothing_to_show", "feature_notification_there_is_nothing_to_show", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 289, 97),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 325, 113),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 245, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 245, 89),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 353, 141),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 257, 89),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 245, 85),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 233, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241, 85),
      ))
    }

internal val Res.string.feature_notification_unexpected_error_subtitle: StringResource by lazy {
      StringResource("string:feature_notification_unexpected_error_subtitle", "feature_notification_unexpected_error_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 387, 150),
        ResourceItem(setOf(LanguageQualifier("bn"), ), "${MD}values-bn/strings.commonMain.cvr", 439, 234),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 331, 138),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 335, 134),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 495, 238),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 347, 130),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 331, 130),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 315, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 327, 118),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_notification_error_oops", Res.string.feature_notification_error_oops)
  map.put("feature_notification_loading", Res.string.feature_notification_loading)
  map.put("feature_notification_nothing_to_notify", Res.string.feature_notification_nothing_to_notify)
  map.put("feature_notification_notifications", Res.string.feature_notification_notifications)
  map.put("feature_notification_there_is_nothing_to_show", Res.string.feature_notification_there_is_nothing_to_show)
  map.put("feature_notification_unexpected_error_subtitle", Res.string.feature_notification_unexpected_error_subtitle)
}
